import React from 'react'
import PropTypes from 'prop-types'
import {Box, useRadio, useRadioGroup} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CheckIcon} from '@salesforce/retail-react-app/app/components/icons'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'

const RadioCardGroupContext = React.createContext()

export const RadioCard = (props) => {
    const getRadioGroupProps = React.useContext(RadioCardGroupContext)
    const {getInputProps, getRadioProps} = useRadio(getRadioGroupProps(props))

    const input = getInputProps()
    const checkbox = getRadioProps()
    return (
        <Box as="label">
            <input {...input} />
            <Box
                {...checkbox}
                aria-hidden={false}
                position="relative"
                cursor="pointer"
                borderColor="gray.200"
                height="full"
                _checked={{
                    border: '1px solid',
                    borderRadius: 0,
                    borderColor: 'cav_calltoaction_darkred'
                }}
                _focus={{
                    boxShadow: 'outline',
                    border: '1px solid',
                    borderRadius: 0,
                    borderColor: 'cav_calltoaction_darkred'
                }}
                px={4}
                py={4}
                className="inputBox"
                boxShadow={`${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} ${
                    colors.blackAlpha[500]
                }`}
            >
                {input.checked && (
                    <Box
                        position="absolute"
                        top={0}
                        right={0}
                        w={0}
                        h={0}
                        borderStyle="solid"
                        borderWidth="0 38px 38px 0"
                        borderColor="transparent"
                        borderRightColor="cav_calltoaction_darkred"
                    >
                        <CheckIcon color="white" position="absolute" right="-40px" top="1px" />
                    </Box>
                )}

                {props.children}
            </Box>
        </Box>
    )
}

export const RadioCardGroup = (props) => {
    const {getRootProps, getRadioProps} = useRadioGroup(props)
    const group = getRootProps()

    return (
        <RadioCardGroupContext.Provider value={getRadioProps}>
            <Box {...group}>{props.children}</Box>
        </RadioCardGroupContext.Provider>
    )
}

RadioCard.propTypes = {children: PropTypes.any}
RadioCardGroup.propTypes = {children: PropTypes.any}
